import { getValidationApiProblem } from '@mkp/shared/data-access';

const EMAIL_PROPERTY_PATH = 'email';

const asString = (value: unknown): string => (typeof value === 'string' ? value : '');

const findEmailViolation = (error: unknown) =>
  getValidationApiProblem(error)?.violations.find(
    (violation) => violation?.propertyPath === EMAIL_PROPERTY_PATH
  );

export const extractEmailFromError = (error: unknown): string =>
  findEmailViolation(error)?.invalidValue ?? '';

export const extractEmailsFromParameters = (
  error: unknown
): { actorEmail: string; invitedEmail: string } => {
  const parameters = findEmailViolation(error)?.parameters;

  return {
    actorEmail: asString(parameters?.['{{ email }}']),
    invitedEmail: asString(parameters?.['{{ invitedEmail }}']),
  };
};
